/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Ajout action Nosto
document.addEventListener('product:added', function(event) {
   if(window.Nosto) {
      Nosto.reloadCart(["mini-cart-rec"])
   }
});

document.addEventListener('cart:updated', function(event) {
   if(window.Nosto) {
      Nosto.reloadCart(["mini-cart-rec"])
   }
});

$(document).ready(function() {

   // Switch language
   var currentPathname = window.location.pathname;
   var currentPathname_French = currentPathname.replace('\/en\/', '');
   $(".english_link").attr("href", "https://www.yves-salomon.com/en"+currentPathname);
   $(".french_link").attr("href", "https://www.yves-salomon.com/"+currentPathname_French);

   // Geolocalisation
   /* if(!sessionStorage.getItem("_ipgeolocation_geolocation")) {
      //getGeoloc();
   } */

   // On replie par défaut les filtres de la colonne de gauche
   $('.CollectionInner .Collapsible__Inner').hide();

   // Sur une page Collection, affiche et masque des filtres sur la gauche
   $('.CollectionInner .Collapsible__Button').click(function (e) {
      $(this).next(".Collapsible__Inner").slideToggle(300, "swing").toggleClass("opened");
      $(this).toggleClass("open");
   });

   // Sur une fiche produit, affiche et masque les sous-rubrique des descriptions
   $('.cat_title').click(function (e) {
      // Si le bloc juste en-dessous du clic est fermé
      if(!$(this).next(".Rte").hasClass("opened")){

         // On ferme tous les Rte ouverts
         $(".Rte.opened").slideToggle(300, "swing", function() {
            $(this).removeClass("opened");
         });

         // On met un "+" sur tous les titres
         $('.cat_title').removeClass("open");

         // Ouvre le rte suivant
         $(this).next(".Rte").slideToggle().addClass("opened");

         // On met un "-" sur le titre cliqué
         $(this).addClass("open");
      }
   });

   // Fermeture éventuelle des popins de redirection
   $(".Modal__Close").click(function(e) {
      if($(".Modal-USA").length)
         $(".Modal-USA").attr("aria-hidden", "true");
      if($(".Modal-UK").length)
         $(".Modal-UK").attr("aria-hidden", "true");
      if($(".Modal-EU").length)
         $(".Modal-EU").attr("aria-hidden", "true");
      if($("#modal-available").length)
         $("#modal-available").attr("aria-hidden", "true");
   });

   $("#dispo_boutiques").click(function(e) {
      $("#modal-available").attr("aria-hidden", "false");
   });
});


// Charger les magasins pour un pays donné dans le select country_select
function show_shops(value) {
   var articles = document.getElementsByClassName("fiche_boutique");
   for (var i = 0; i < articles.length; i++) {
      articles[i].style = 'display:none'
      if (articles[i].dataset.pays == value) {
         articles[i].style = 'display:block'
      }
   }
}

// Sur la page Boutique, on met à jour la liste des boutiques
window.addEventListener('load', function () {
   var myselect = document.getElementById("country_select");
   if(myselect){
      show_shops(myselect.value);

      // Au changement dans la liste
      myselect.addEventListener('change', (event) => {
         show_shops(event.target.value); // Mise à jour de la liste des magasins
      })
   }
});

// Voir plus sur les sections SEO
$(".read_more").click(function () {
  $(this).prev(".seo_content_rte").toggleClass("extend");
});

function getGeoloc(){
   // Sur tout le site pour la géolocalisation
   _ipgeolocation.enableSessionStorage(true);

   // Code des pays livrables
   var pays_livrable = ["FR", "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE", "AD", "LI", "MC", "CH", "TR"]

   // Si première visite
   _ipgeolocation.makeAsyncCallsToAPI(false);
   _ipgeolocation.setFields("country_name,country_code2");
   _ipgeolocation.getGeolocation(handleResponse, "4a47d1340eb44df6952180109b773049");

   var country = JSON.parse(sessionStorage.getItem("_ipgeolocation_geolocation"));
   var country_name = country['country_name'];
   //document.getElementById('modal_pays').innerHTML = country_name;

   if(!pays_livrable.includes(country_code2)){
      if(country_code2 == "US"){
         $(".Modal-USA").attr("aria-hidden", "false");
      }
      else if (country_code2 == "GB") {
         $(".Modal-UK").attr("aria-hidden", "false");
      }
   }

   // On récupère le nom et le code du pays
   function handleResponse(json) {
      country_name = json.country_name;
      country_code2 = json.country_code2;
   }
}
